export default {
  'Submit': 'ส่ง',
  'Save': 'บันทึก',
  'enterOTP': 'ใส่ OTP',
  'otpSent': 'OTP ส่งแล้ว',
  'login/signup': 'เข้าสู่ระบบ/ ลงทะเบียน',
  'resendCode': 'ส่งรหัสอีกครั้ง',
  'edit': 'แก้ไข',
  'otpMessage': 'รหัส 6 ตัว ถูกส่งไปยังเบอร์มือถือของคุณ',
  'oyo360WelcomeMessage': 'เข้าสู่ระบบ/ ลงทะเบียน',
  'oyo360ResendCode': 'ส่งรหัสอีกครั้ง',
  'oyo360Edit': 'แก้ไข',
  'oyo360otpMessage': 'รหัส 6 ตัว ถูกส่งไปยังเบอร์มือถือของคุณ',
  'buttonActionContinue': 'ดำเนินการต่อ',
  'chooseLanguage': 'เลือกภาษา',
  'currentLanguage': 'ภาษาปัจจุบัน',
  'otherLanguages': 'ภาษาอื่น',
  'google': 'Google',
  'facebook': 'Facebook',
  'or': 'หรือ',
  'buttonActionSubmit': 'ส่ง',
  'welcomeTitle': 'ยินดีต้อนรับสู่โอโย',
  'welcomeHeadingForMailLogin': 'กรอกอีเมลที่ลงทะเบียนไว้',
  'welcomeHeadingForPhoneLogin': 'กรอกเบอร์โทรศัพท์ที่ลงทะเบียนไว้',
  'welcomeHeadingForLogin': 'กรุณาใส่อีเมล์หรือเบอร์โทรศัพท์ที่ลงทะเบียนไว้',
  'userNameLabel': 'อีเมล์/เบอร์โทรศัพท์',
  'userNameErrorMessage':'กรุณาใส่อีเมล์หรือเบอร์โทรศัพท์ที่ถูกต้อง',
  'emailIdLabel': 'อีเมล',
  'phoneNumberLabel': 'เบอร์โทรศัพท์',
  'passwordLabel': 'รหัสผ่าน',
  'newPasswordLabel': 'รหัสผ่านใหม่',
  'confirmNewPasswordLabel': 'ยืนยันรหัสผ่านใหม่',
  'emailErrorMessage': 'กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง',
  'phoneNumberErrorMessage': 'กรุณาใส่เบอร์โทรศัพท์ที่ถูกต้อง',
  'passwordErrorMessage': 'กรุราใส่รหัสผ่านที่ถูกต้อง',
  'confirmPasswordErrorMessage': 'รหัสผ่านไม่ถูกต้อง',
  'generateNewPassword': 'สร้างรหัสผ่านใหม่',
  'loginButtonLabel': 'เข้าสู่ระบบ',
  'loginWithPhoneButtonLabel': 'ดำเนินการต่อด้วยโทรศัพท์',
  'loginWithOtp': 'เข้าสู่ระบบด้วย OTP',
  'loginWithEmailButtonLabel': 'ดำเนินการต่อด้วยอีเมล',
  'back': 'ย้อนกลับ',
  'loginWithOtpTitle': 'ใส่รหัสยืนยัน',
  'loginWithOtpHeading': 'รหัส 6 ตัว ถูกส่งไปยังเบอร์มือถือของคุณ',
  'listYourProperty': 'ลงรายกาที่พักของคุณ',
  'privacyPolicy': 'นโยบายความเป็นส่วนตัว',
  'verifyEmail': 'ยืนยันที่อยู่อีเมล',
  'verifyMobile': 'ยืนยันหมายเลขโทรศัพท์มือถือ',
  'forgotPasswordPhoneSubHeading': 'เราจะส่งรหัส 6 ตัว เพื่อยืนยันเบอร์มือถือของคุณ',
  'forgotPasswordMailSubHeading': 'เราจะส่งรหัส 6 ตัว เพื่อยืนยันอีเมลของคุณ',
  'newPasswordCondition1': 'ต้องมีตัวเลขและสัญลักษณ์',
  'newPasswordCondition2': 'ต้องมีอย่างน้อย 8 ตัวอักษร',
  'newPasswordCondition3': 'ต้องมีทั้งตัวอักษรพิมพ์ใหญ่และพิมพ์เล็ก',
  'confirmLogin': 'ยืนยันและเข้าสู่ระบบ',
  'getOTP': 'รับ OTP',
  'invalidInput': 'รหัสไม่ถูกต้อง',
  'passwordResetMessage': 'สร้างรหัสผ่านสำเร็จ',
  'otpErrorMessage': 'กรุณาใส่ OTP ให้ถูกต้อง',
  'resendOtpSuccessMessage': 'OTP ถูกส่งไปยังเบอร์มือถืออีกครั้งเรียบร้อยแล้ว',
  'InternalServerErrorMessage': 'ข้อผิดพลาดภายในเซิร์ฟเวอร์',
  'resetPasswordHeading': 'รหัส 6 ตัว ถูกส่งไปยังอีเมลและเบอร์มือถือของคุณ',
  'signingIn': 'กำลังเข้าสุ่ระบบ',
  'invalidMobileNumber': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
  'privacyFooterText': 'การลงชื่อเข้าใช้บัญชีของคุณแสดงว่าคุณยอมรับ{termsOfUse}และ{privacyPolicy}ของเรา',
  'and': 'และ',
  'termsOfUse': 'ข้อกำหนดการใช้งาน',
  'listProperty': 'ลงรายกาที่พักของคุณ',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels':
    '\u0e04\u0e38\u0e13\u0e44\u0e21\u0e48\u0e21\u0e35\u0e42\u0e23\u0e07\u0e41\u0e23\u0e21\u0e17\u0e35\u0e48\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e02\u0e49\u0e2d\u0e07',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'passwordChangeInformationText': 'คุณจะถูกออกจากระบบจากอุปกรณ์ทั้งหมด หลังจากเปลี่ยนรหัสผ่าน'
};
